<template>
    <modal :name="modalName" class="merge-accounts-modal">
        <div class="modal-title">
            <span>
                <b>Merge accounts</b>
                <span class="modal-desc">Select email to which you want to merge other accounts.</span>
            </span>
            <img src="../../assets/images/x-icon-grey.svg" alt="X Icon" @click="actionHide">
        </div>
        <div class="user-rows">
            <merge-accounts-user v-for="selectedItem in selectedItems" :user="selectedItem"
                                 v-bind:key="selectedItem.id"/>
        </div>
        <text-button label="merge accounts" :loading-state="loadingState" @click="actionMerge"/>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";
    import MergeAccountsUser from "./MergeAccountsUser";
    import TextButton from "../components/TextButton";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "MergeAccountsModal",
        components: {TextButton, MergeAccountsUser, Modal},
        computed: {
            modalName() {
                return this.$enums.ModalNameEnum.MERGE_ACCOUNTS;
            },
            ...mapGetters('app', {
                selectedItems: 'getSelectedItems'
            })
        },
        data() {
            return {
                activeUserId: null,
                loadingState: false,
            }
        },
        methods: {
            actionHide() {
                this.$modals.hide(this.modalName);
            },
            actionMerge() {
                this.loadingState = true;

                this.$api.mergeAccounts({
                    data: {
                        main: this.activeUserId,
                        accounts: this.selectedItems.map(selectedItem => {
                            return selectedItem.id;
                        }),
                    }
                }).then(() => {
                    this.$parent.$parent.initUsers();
                    this.clearSelectedItems();
                }).finally(() => {
                    this.loadingState = false;
                    this.actionHide();
                })
            },
            ...mapMutations('app', {
                clearSelectedItems: 'clearSelectedItems',
            })
        },
        mounted() {
            this.activeUserId = this.selectedItems[0].id;
        }
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .merge-accounts-modal {
        .modal {
            width: 480px;
            background-color: $bg-color-2 !important;
        }
    }
</style>